<template>
  <admin-navbar>
    <main v-if="isMode === 'A'" class="space-y-5">
      <h1 class="text-lg font-bold">МУУҮА-ийн гүшүүн байгууллагууд</h1>

      <div
        class="flex flex-col gap-4 bg-white rounded p-3 h-[80vh] overflow-y-scroll"
      >
        <button
          @click="setMode('B')"
          class="bg-blue-500 p-2 text-white text-xs rounded w-fit hover:bg-blue-600"
        >
          <font-awesome-icon icon="fa-solid fa-add" class="mr-1" />
          Шинэ гишүүн нэмэх
        </button>

        <!-- FILTER -->
        <div class="flex items-center bg-gray-200 w-full rounded text-xs p-2">
          <label for="searchQuery" class="mr-2">Байгууллагын нэр:</label>
          <input
            id="searchQuery"
            name="searchQuery"
            type="text"
            placeholder="Хайх..."
            class="rounded p-1 mr-5 w-[20rem] border"
            v-model="searchQuery"
            @keyup.enter="filterCompanies"
          />

          <button
            @click="filterCompanies()"
            class="bg-blue-500 p-1 rounded text-white mr-2"
          >
            <font-awesome-icon icon="fa-solid fa-filter" class="mr-1" />Шүүх
          </button>
          <button
            @click="resetFilter()"
            class="bg-amber-500 p-1 rounded text-white"
          >
            <font-awesome-icon icon="fa-solid fa-eraser" class="mr-1" />Арилгах
          </button>
        </div>

        <MMCompaniesTable
          v-if="filteredCompanies.length > 0 && !isLoading"
          :data="filteredCompanies"
          @setMode="switchMode"
          @fetchData="fetchData"
        />

        <div
          v-else-if="filteredCompanies.length === 0 && !isLoading"
          class="flex justify-center items-center h-[40vh]"
        >
          Жагсаалт хоосон байна
        </div>

        <div v-else class="flex justify-center items-center h-[40vh]">
          <spin-loading />
        </div>
      </div>
    </main>

    <main v-else>
      <MMEditCompanies
        v-if="isMode === 'B'"
        :data="selectedData"
        @cancel-edit="setMode('A')"
      />
    </main>
  </admin-navbar>
</template>

<script>
import AdminNavbar from "@/components/admin/AdminNavbar.vue";
import SpinLoading from "@/components/ui/SpinLoading.vue";
import adminInstance from "@/lib/adminInstance";
import { onMounted, ref } from "vue";
import MMCompaniesTable from "@/containers/MiningMongolia/admin/MMCompaniesTable";
import MMEditCompanies from "@/containers/MiningMongolia/admin/MMEditCompanies";

export default {
  name: "MMMemberCompanies",
  components: {
    AdminNavbar,
    SpinLoading,
    MMCompaniesTable,
    MMEditCompanies,
  },
  setup() {
    const isMode = ref("A");
    const selectedData = ref(null);
    const companies = ref([]);
    const filteredCompanies = ref([]);
    const isLoading = ref(false);
    const searchQuery = ref("");

    const switchMode = (mode, data) => {
      isMode.value = mode;
      selectedData.value = data;
    };

    const fetchData = async () => {
      try {
        isLoading.value = true;
        const res = await adminInstance.get("/get/member-companies");
        if (res.status === 200) {
          companies.value = res.data.members;
          filteredCompanies.value = [...res.data.members];
        }
      } catch (err) {
        return err;
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      fetchData();
    });

    const setMode = (mode) => {
      isMode.value = mode;
      if (mode === "A") {
        selectedData.value = null;
        fetchData();
      }
    };

    const filterCompanies = () => {
      try {
        isLoading.value = true;
        const query = searchQuery.value.toLowerCase();
        filteredCompanies.value = companies.value.filter((company) =>
          company.name.toLowerCase().includes(query)
        );
      } catch (err) {
        return err;
      } finally {
        isLoading.value = false;
      }
    };

    const resetFilter = () => {
      searchQuery.value = "";
      filteredCompanies.value = [...companies.value];
    };

    return {
      isMode,
      switchMode,
      companies,
      isLoading,
      selectedData,
      setMode,
      fetchData,
      filteredCompanies,
      searchQuery,
      filterCompanies,
      resetFilter,
    };
  },
};
</script>
